import {Component, Input, ChangeDetectionStrategy} from '@angular/core';


@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {
  @Input() header: string = 'Geen producten gevonden';
  @Input() imageSrc: string = '/wifi.png';
}
